module.exports = __webpack_public_path__ + "img/159.be1497ed.jpg";